module.exports = __webpack_public_path__ + "img/hi-bike-logo.5f91b6e1.png";